import { GlobeAltIcon } from '@heroicons/react/outline';
import Image from 'next/image';
import Link from 'next/link';
import useLocale from 'next-translate/useTranslation';
import { useEffect, useRef, useState } from 'react';

import SunSVG from '~/svg/Sun.svg';

// LazyVideo component for better lazy loading
interface LazyVideoProps {
  src: string;
  poster: string;
  className: string;
}

const LazyVideo = ({ src, poster, className }: LazyVideoProps) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          if (videoRef.current) {
            videoRef.current.load();
            observer.unobserve(videoRef.current);
          }
        }
      },
      { threshold: 0.1 },
    );

    if (videoRef.current) {
      observer.observe(videoRef.current);
    }

    return () => {
      if (videoRef.current) {
        observer.unobserve(videoRef.current);
      }
    };
  }, []);

  return (
    <video
      ref={videoRef}
      className={className}
      autoPlay={isVisible}
      loop
      muted
      playsInline
      preload='none'
      poster={poster}
    >
      {isVisible && <source src={src} type='video/mp4' />}
    </video>
  );
};

const PluginHowItWorks = () => {
  const { t, lang } = useLocale('b2b');

  return (
    <div
      id='features'
      className='relative overflow-hidden  pb-32 dark:bg-slate-900'
    >
      <div className='bg-gray-50 py-16 dark:bg-slate-800'>
        <div className='mx-auto max-w-xl px-4 text-center sm:px-6 lg:max-w-7xl lg:px-8'>
          <h2 className='mx-auto mt-2  max-w-3xl bg-gradient-to-r from-purple-600 via-red-500 to-primary-600 bg-clip-text text-center text-3xl font-bold tracking-tight text-transparent  sm:text-4xl'>
            {t('You Need 3 mins to Get It Done')}
          </h2>
          <p className='mx-auto mt-5 max-w-prose text-xl text-gray-500 dark:text-slate-400'>
            {t(
              'This plugin deploys a smart, customizable chatbot based on your configurations from the Easy-Peasy.AI platform, helping you provide a more interactive and responsive experience for your website users.',
            )}
          </p>
          {/* <dl className='mt-12 space-y-10 text-center lg:grid lg:grid-cols-3 lg:gap-8 lg:space-y-0'>
            {chatModels
              .filter((feature) => !feature.hidden)
              .map((feature) => (
                <div key={feature.id}>
                  <dt className='text-center'>
                    <div className='mx-auto flex h-10 w-10 items-center justify-center rounded-md bg-slate-800 dark:bg-slate-800  text-white'>
                      <feature.icon className='h-4 w-4' aria-hidden='true' />
                    </div>
                    <strong className='mt-5 block text-lg font-medium leading-6 text-gray-900 dark:text-slate-300'>
                      {t(feature.title)}
                    </strong>
                  </dt>
                  <dd className='mt-2 text-base text-gray-500'>
                    {t(feature.description)}
                  </dd>
                </div>
              ))}
          </dl> */}
        </div>
      </div>

      {/* <div className='relative'>
        <div className='lg:mx-auto lg:grid lg:max-w-7xl lg:grid-flow-col-dense lg:grid-cols-2 lg:gap-24 lg:px-8'>
          <div className='mx-auto max-w-xl px-4 sm:px-6 lg:mx-0 lg:max-w-none lg:py-16 lg:px-0'>
            <div>
              <div>
                <span className='flex h-12 w-12 items-center justify-center rounded-md bg-gradient-to-r from-purple-600 to-indigo-600'>
                  <SparklesIcon
                    className='h-6 w-6 text-white'
                    aria-hidden='true'
                  />
                </span>
              </div>
              <div className='mt-6'>
                <h2 className='text-3xl font-bold tracking-tight text-gray-900 dark:text-slate-200'>
                  {t('Create amazing content 10X faster')}
                </h2>
                <p className='mt-4 text-lg text-gray-500 dark:text-slate-400'>
                  {lang != 'en' && t('feature_text_description')}
                  {lang === 'en' && (
                    <>
                      Easy-Peasy.AI is an AI Content tool that can help you with
                      a variety of writing tasks, from writing blog post,
                      creating better resumes and job descriptions to composing
                      emails and social media content, and many more. With{' '}
                      <b>90+</b> templates, Easy-Peasy.AI can save you time and
                      improve your writing skills.
                    </>
                  )}
                </p>
                {!isSpecialOffer && (
                  <div className='mt-6'>
                    <Link
                      href='/templates'
                      className='inline-flex rounded-md border border-transparent bg-gradient-to-r from-purple-600 to-indigo-600 bg-origin-border px-4 py-2 text-base font-medium text-white shadow-sm hover:from-purple-700 hover:to-indigo-700'
                    >
                      {t('Learn more')}
                    </Link>
                  </div>
                )}
              </div>
            </div>
            <div className='mt-8 border-t border-gray-200 pt-6 dark:border-white/10'>
              <blockquote>
                <div>
                  <p className='text-base text-gray-500 dark:text-slate-400'>
                    &ldquo;{t('feature_review_text')}&rdquo;
                  </p>
                </div>
                <footer className='mt-3'>
                  <div className='flex items-center space-x-3'>
                    <div className='text-base font-medium text-gray-700 dark:text-slate-600'>
                      {t('feature_review_name')}
                    </div>
                  </div>
                </footer>
              </blockquote>
            </div>
          </div>
          <div className='mt-12 sm:mt-16 lg:mt-0'>
            <div className='-pl-4 sm:pl-6 md:-mr-16 lg:relative lg:m-0 lg:h-full lg:px-0'>
              <img
                className='w-full rounded-xl shadow-xl ring-1 ring-black ring-opacity-5 lg:absolute lg:left-0 lg:h-full lg:w-auto lg:max-w-none'
                src='/images/presets3.png'
                alt='90 AI Copywriting Templates'
              />
            </div>
          </div>
        </div>
      </div> */}
      <div className='relative mt-24' id='chat'>
        <div className='lg:mx-auto lg:grid lg:max-w-7xl lg:grid-flow-col-dense lg:grid-cols-2 lg:gap-24 lg:px-8'>
          <div className='mx-auto max-w-xl px-4 sm:px-6 lg:mx-0 lg:max-w-none lg:px-0 lg:py-16'>
            <div>
              <div>
                <span className='flex h-12 w-12 items-center justify-center rounded-md bg-gradient-to-r from-purple-600 to-indigo-600'>
                  <SunSVG className='h-6 w-6 text-white' aria-hidden='true' />
                </span>
              </div>
              <div className='mt-6'>
                <h2 className='text-3xl font-bold tracking-tight text-gray-900 dark:text-slate-200'>
                  {t('Log into Your Easy-Peasy.AI Account')}
                </h2>
                <p className='mt-4 text-lg text-gray-500 dark:text-slate-400'>
                  {t(
                    "Begin by signing into your account. If you haven't registered yet, create your free account. Once logged in, go to the Bots section and select the chatbot you'd like to add to your site.",
                  )}
                </p>
              </div>
            </div>
          </div>
          <div className='mt-12 sm:mt-16 lg:mt-20'>
            <div className='relative h-[300px] w-full'>
              <img
                src='/images/plugins/image (32).png'
                className='absolute h-full w-full rounded-xl object-cover shadow-xl ring-1 ring-black ring-opacity-5'
                alt='Bots page interface'
              />
            </div>
          </div>
        </div>
      </div>
      <div className='mt-24' id='ai-images'>
        <div className='lg:mx-auto lg:grid lg:max-w-7xl lg:grid-flow-col-dense lg:grid-cols-2 lg:gap-24 lg:px-8'>
          <div className='mx-auto max-w-xl px-4 sm:px-6 lg:col-start-2 lg:mx-0 lg:max-w-none lg:px-0 lg:py-32'>
            <div>
              <div>
                <span className='flex h-12 w-12 items-center justify-center rounded-md bg-gradient-to-r from-purple-600 to-indigo-600'>
                  <GlobeAltIcon
                    className='h-6 w-6 text-white'
                    aria-hidden='true'
                  />
                </span>
              </div>
              <div className='mt-6'>
                <h2 className='text-3xl font-bold tracking-tight text-gray-900 dark:text-slate-200'>
                  {t('Install the Easy-Peasy.AI Plugin on WordPress')}
                </h2>
                <div className='mt-4 text-lg text-gray-500 dark:text-slate-400'>
                  <ol className='list-decimal space-y-4 pl-4'>
                    <li>
                      <p className='font-medium'>
                        {t('Access Your WordPress Admin Panel')}
                      </p>
                      <ul className='mt-2 list-disc pl-4'>
                        <li>
                          {t(
                            "Navigate to your website's admin area (usually at yourdomain.com/wp-admin)",
                          )}
                        </li>
                      </ul>
                    </li>
                    <li>
                      <p className='font-medium'>{t('Add the Plugin')}</p>
                      <ul className='mt-2 list-disc pl-4'>
                        <li>
                          {t(
                            'In the dashboard sidebar, click on Plugins > Add New',
                          )}
                        </li>
                        <li>{t('Search for Easy-Peasy.AI')}</li>
                        <li>{t('Locate the plugin')}</li>
                        <li>{t('Click Install Now, then Activate')}</li>
                      </ul>
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
          <div className='mt-12 sm:mt-16 lg:col-start-1 lg:mt-40'>
            <div className='relative h-[300px] w-full'>
              <img
                src='/images/plugins/image (33).png'
                className='absolute h-full w-full rounded-xl object-cover shadow-xl ring-1 ring-black ring-opacity-5'
                alt='Bots page interface'
              />
            </div>
          </div>
        </div>
      </div>
      <div className='relative mt-24' id='chat'>
        <div className='lg:mx-auto lg:grid lg:max-w-7xl lg:grid-flow-col-dense lg:grid-cols-2 lg:gap-24 lg:px-8'>
          <div className='mx-auto max-w-xl px-4 sm:px-6 lg:mx-0 lg:max-w-none lg:px-0 lg:py-16'>
            <div>
              <div>
                <span className='flex h-12 w-12 items-center justify-center rounded-md bg-gradient-to-r from-purple-600 to-indigo-600'>
                  <SunSVG className='h-6 w-6 text-white' aria-hidden='true' />
                </span>
              </div>
              <div className='mt-6'>
                <h2 className='text-3xl font-bold tracking-tight text-gray-900 dark:text-slate-200'>
                  {t('Configure Your Chatbot')}
                </h2>
                <p className='mt-4 text-lg text-gray-500 dark:text-slate-400'>
                  <ul className='mt-2 list-disc pl-4'>
                    <li>
                      {t(
                        'In the dashboard, go to Settings > Easy-Peasy.AI Bot',
                      )}
                    </li>
                    <li>{t('Enter your Bot ID in the provided textbox')}</li>
                  </ul>
                </p>
              </div>
            </div>
          </div>
          <div className='mt-12 sm:mt-16 lg:mt-20'>
            <div className='relative h-[300px] w-full'>
              <img
                src='/images/plugins/image (34).png'
                className='absolute h-full w-full rounded-xl object-cover shadow-xl ring-1 ring-black ring-opacity-5'
                alt='Bots page interface'
              />
            </div>
          </div>
        </div>
      </div>
      <div className='mt-24' id='ai-images'>
        <div className='lg:mx-auto lg:grid lg:max-w-7xl lg:grid-flow-col-dense lg:grid-cols-2 lg:gap-24 lg:px-8'>
          <div className='mx-auto max-w-xl px-4 sm:px-6 lg:col-start-2 lg:mx-0 lg:max-w-none lg:px-0 lg:py-32'>
            <div>
              <div>
                <span className='flex h-12 w-12 items-center justify-center rounded-md bg-gradient-to-r from-purple-600 to-indigo-600'>
                  <GlobeAltIcon
                    className='h-6 w-6 text-white'
                    aria-hidden='true'
                  />
                </span>
              </div>
              <div className='mt-6'>
                <h2 className='text-3xl font-bold tracking-tight text-gray-900 dark:text-slate-200'>
                  {t('Retrieve Your Bot ID')}
                </h2>
                <p className='mt-4 text-lg text-gray-500 dark:text-slate-400'>
                  <ul className='mt-2 list-disc pl-4'>
                    <li>{t('Log into your easy-peasy.ai account')}</li>
                    <li>{t('Select your desired bot and click Edit')}</li>
                    <li>
                      {t(
                        'Navigate to the Embedding section to find your unique Bot ID',
                      )}
                    </li>
                    <li>{t('Copy this ID')}</li>
                  </ul>
                </p>
              </div>
            </div>
          </div>
          <div className='mt-12 sm:mt-16 lg:col-start-1 lg:mt-40'>
            <div className='relative h-[300px] w-full'>
              <img
                src='/images/plugins/image (36).png'
                className='absolute h-full w-full rounded-xl object-cover shadow-xl ring-1 ring-black ring-opacity-5'
                alt='Bots page interface'
              />
            </div>
          </div>
        </div>
      </div>

      <div className='relative mt-24' id='chat'>
        <div className='lg:mx-auto lg:grid lg:max-w-7xl lg:grid-flow-col-dense lg:grid-cols-2 lg:gap-24 lg:px-8'>
          <div className='mx-auto max-w-xl px-4 sm:px-6 lg:mx-0 lg:max-w-none lg:px-0 lg:py-16'>
            <div>
              <div>
                <span className='flex h-12 w-12 items-center justify-center rounded-md bg-gradient-to-r from-purple-600 to-indigo-600'>
                  <SunSVG className='h-6 w-6 text-white' aria-hidden='true' />
                </span>
              </div>
              <div className='mt-6'>
                <h2 className='text-3xl font-bold tracking-tight text-gray-900 dark:text-slate-200'>
                  {t('Embed the Bot into WordPress')}
                </h2>
                <p className='mt-4 text-lg text-gray-500 dark:text-slate-400'>
                  <ul className='mt-2 list-disc pl-4'>
                    <li>
                      {t(
                        "Paste the copied Bot ID into the plugin's settings page",
                      )}
                    </li>
                    <li>{t('Save your changes')}</li>
                  </ul>
                </p>
              </div>
            </div>
          </div>
          <div className='mt-12 sm:mt-16 lg:mt-20'>
            <div className='relative h-[300px] w-full'>
              <img
                src='/images/plugins/image (37).png'
                className='absolute h-full w-full rounded-xl object-cover shadow-xl ring-1 ring-black ring-opacity-5'
                alt='Bots page interface'
              />
            </div>
          </div>
        </div>
      </div>
      {/* <div className='mt-24' id='ai-transcription'>
        <div className='lg:mx-auto lg:grid lg:max-w-7xl lg:grid-flow-col-dense lg:grid-cols-2 lg:gap-24 lg:px-8'>
          <div className='mx-auto max-w-xl px-4 sm:px-6 lg:col-start-2 lg:mx-0 lg:max-w-none lg:py-32 lg:px-0'>
            <div>
              <div>
                <span className='flex h-12 w-12 items-center justify-center rounded-md bg-gradient-to-r from-purple-600 to-indigo-600'>
                  <FaRocket className='h-6 w-6 text-white' aria-hidden='true' />
                </span>
              </div>
              <div className='mt-6'>
                <h2 className='text-3xl font-bold tracking-tight text-gray-900 dark:text-slate-200'>
                  {t(
                    'GPT-4, Chat Personas, Voice Commands, Chat History and more!'
                  )}
                </h2>
                <p className='mt-4 text-lg text-gray-500 dark:text-slate-400'>
                  {t(
                    "Dive into MARKY's cutting-edge functionalities, including GPT-4 technology, adaptable chat personas, intuitive voice commands, and accessible chat history. Explore an immersive chat experience that evolves with your needs and enhances your communication."
                  )}
                </p>
              </div>
            </div>
          </div>
          <div className='mt-12 sm:mt-16 lg:col-start-1 lg:mt-0'>
            <div className=' pr-4 sm:pr-6 md:-ml-16 lg:relative lg:m-0 lg:h-full lg:px-0'>
              <img
                className='w-full rounded-xl shadow-xl ring-1 ring-black ring-opacity-5 lg:absolute lg:right-0 lg:h-full lg:w-auto lg:max-w-none'
                src='/images/more-chat-features.png'
                alt='GPT-4, Chat Personas, Voice Commands, Chat History and more!'
              />
            </div>
          </div>
        </div>
      </div> */}
      <div className='mt-24 sm:flex sm:justify-center'>
        <div className='rounded-md shadow'>
          <Link
            href='/Easy-Peasy-AI-Bot-Wordpress.zip'
            target='_blank'
            className='flex w-full items-center justify-center rounded-md border border-transparent bg-primary-600 px-8 py-3 text-base font-medium text-white hover:bg-primary-700 md:px-10 md:py-4 md:text-lg'
          >
            {t('Download the Plugin')}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PluginHowItWorks;
